import { render, staticRenderFns } from "./SkillList.vue?vue&type=template&id=22a7f751&scoped=true"
import script from "./SkillList.vue?vue&type=script&lang=js"
export * from "./SkillList.vue?vue&type=script&lang=js"
import style0 from "./SkillList.vue?vue&type=style&index=0&id=22a7f751&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a7f751",
  null
  
)

export default component.exports